/* HUNTERS WORLD Weihnachts-Wildbestellung
   Gehört zu sections/weihnachts-wild.liquid. Reiter, Mengen, Mengenrechner, Kalender nach
   Öffnungszeiten und Feiertagen, Lieferung mit PLZ-Prüfung (100 km), Rezepte mit
   umgerechneten Mengen und PDF-Download (html2canvas + jsPDF, erst beim Klick geladen). */
(function () {
  'use strict';

  /* PLZ im Umkreis von 100 km um das Geschäft (Luftlinie, Stand 28.07.2026, Stern = Platzhalter) */
  var PLZ = "800*,802*,803*,804*,805*,806*,807*,808*,809*,812*,813*,814*,815*,816*,817*,818*,819*,820*,821*,822*,823*,824*,825*,830*,831*,835*,836*,837*,840*,841*,850*,851*,852*,853*,854*,855*,856*,857*,858*,862*,863*,864*,865*,866*,868*,869*,876*,893*,894*,918*,933*,73450,73467,73469,83209,83224,83228,83229,83233,83236,83250,83253,83254,83256,83257,83259,83301,83308,83339,83342,83349,83352,83355,83358,83361,83365,83368,83370,83371,83374,83376,84323,84339,84405,84416,84419,84424,84427,84428,84431,84432,84434,84435,84437,84439,84453,84478,84494,84503,84513,84518,84524,84539,84543,84544,84546,84549,84550,84552,84553,84555,84556,84558,84559,84562,84564,84565,84568,84570,84571,84573,84574,84576,84577,84579,86121,86130,86131,86132,86133,86134,86136,86140,86141,86142,86143,86144,86145,86147,86150,86152,86153,86154,86156,86157,86159,86161,86163,86165,86167,86169,86177,86179,86197,86199,86700,86701,86703,86704,86706,86707,86709,86720,86732,86733,86735,86736,86738,86739,86741,86744,86745,86747,86748,86750,86751,86753,86754,86756,86757,86759,87428,87435,87437,87443,87459,87463,87466,87471,87484,87488,87490,87493,87494,87496,87499,87700,87719,87724,87727,87730,87733,87734,87736,87737,87739,87740,87742,87743,87745,87746,87748,87749,87751,87752,87754,87755,87757,87758,87760,87761,87766,87767,87769,87770,87772,87773,87775,87776,87778,87779,87781,87782,87784,87785,87787,87789,88450,88451,88453,88457,88481,88486,89090,89129,89165,89168,89176,89186,89192,89250,89257,89264,89269,89275,89278,89281,89284,89287,89290,89291,89293,89294,89296,89297,89299,89537,89542,89561,89564,89567,89568,90317,91171,91177,91180,91719,91723,91741,91747,91757,91780,91781,91785,91788,91790,91792,91793,91795,91796,91798,91799,92334,92339,92345,92363,92400,93012,93013,93037,93038,93039,93040,93041,93042,93043,93047,93049,93051,93053,93065,93072,93077,93080,93083,93087,93089,93095,93096,93098,93101,93107,93152,93155,93161,93176,93180,93186,93188,94333,94419";

  /* Rezepte, Mengen für "basis" Personen. Fleischteil trägt "teil" (Name wie in der Liste). */
  var REZEPTE = [
 {
  "id": "reh-ruecken",
  "wild": "reh",
  "titel": "Rosa Rehrücken mit Wacholderjus zum Fest",
  "basis": 4,
  "zeit_arbeit": "1 Std.",
  "zeit_gesamt": "2 Std. 30 Min. + 1 Tag Marinieren",
  "schwierigkeit": "pfiffig",
  "kern": "54 bis 56 °C (rosa)",
  "zutaten": [
   {
    "m": 750,
    "e": "g",
    "t": "Rehrücken, ausgelöst und pariert",
    "teil": "Rücken ohne Knochen"
   },
   {
    "m": 2,
    "e": "EL",
    "t": "Olivenöl zum Einreiben"
   },
   {
    "m": 7,
    "e": "Stk",
    "t": "Wacholderbeeren, angedrückt"
   },
   {
    "m": null,
    "e": "",
    "t": "grober schwarzer Pfeffer"
   },
   {
    "m": null,
    "e": "",
    "t": "Salz"
   },
   {
    "m": 70,
    "e": "g",
    "t": "Butter zum Braten"
   },
   {
    "m": 3,
    "e": "EL",
    "t": "Olivenöl für den Jus"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "Zwiebel mit Schale, halbiert"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "kleine Lauchstange"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "Möhre"
   },
   {
    "m": 20,
    "e": "g",
    "t": "Knollensellerie"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "Petersilienwurzel"
   },
   {
    "m": 30,
    "e": "g",
    "t": "Schinkenwürfel"
   },
   {
    "m": 1,
    "e": "Zehe",
    "t": "Knoblauch, angedrückt"
   },
   {
    "m": 1,
    "e": "Blatt",
    "t": "Lorbeer"
   },
   {
    "m": 0.5,
    "e": "TL",
    "t": "getrockneter Thymian"
   },
   {
    "m": 0.5,
    "e": "TL",
    "t": "weiße Pfefferkörner, geschrotet"
   },
   {
    "m": 0.5,
    "e": "TL",
    "t": "Wacholderbeeren, angedrückt"
   },
   {
    "m": 350,
    "e": "ml",
    "t": "trockener Rotwein"
   },
   {
    "m": 500,
    "e": "ml",
    "t": "Wildfond (gern selbst gekocht)"
   },
   {
    "m": 1,
    "e": "TL",
    "t": "Senf"
   },
   {
    "m": 1,
    "e": "TL",
    "t": "Johannisbeergelee"
   },
   {
    "m": null,
    "e": "",
    "t": "Crema di Balsamico zum Abschmecken"
   },
   {
    "m": 20,
    "e": "g",
    "t": "eiskalte Butter in Stückchen"
   }
  ],
  "schritte": [
   "Befreie die Rückenstränge von Sehnen und Silberhaut, reibe sie mit Öl, zerdrückten Wacholderbeeren und grobem Pfeffer ein und lass sie in Folie gewickelt ein bis zwei Tage im Kühlschrank ziehen.",
   "Röste für den Jus das klein geschnittene Gemüse mit den Schinkenwürfeln und der Zwiebel (Schnittfläche nach unten) in Öl kräftig an, lösche mit einem Teil des Rotweins ab und lass ihn einkochen.",
   "Gib restlichen Rotwein, Wildfond und die Gewürze dazu und lass alles offen kräftig köcheln, bis etwa 300 ml übrig sind. Gieß den Jus dann durch ein feines Sieb.",
   "Würze den Jus mit Senf, Johannisbeergelee, Salz, Pfeffer und etwas Crema di Balsamico und bind ihn kurz vor dem Servieren mit den kalten Butterstückchen.",
   "Nimm das Fleisch ein bis zwei Stunden vorher aus dem Kühlschrank. Lass die Butter in einer flachen Form im 200 °C heißen Ofen (Ober-/Unterhitze) schmelzen, ohne dass sie braun wird.",
   "Leg die Stränge in die heiße Butter, salze leicht und wende sie etwa alle 2 Minuten. Nach 8 bis 10 Minuten sollte der Kern 54 bis 56 °C erreicht haben.",
   "Wickel das Fleisch in Alufolie und lass es 10 Minuten ruhen, bevor du es aufschneidest und mit dem Jus servierst."
  ],
  "beilage": "Dazu passen Spätzle oder Selleriepüree mit gebratenen Waldpilzen und Rosenkohlblättchen."
 },
 {
  "id": "reh-keule",
  "wild": "reh",
  "titel": "Geschmorte Rehkeule in Backpflaumen-Portwein-Soße",
  "basis": 4,
  "zeit_arbeit": "30 Min.",
  "zeit_gesamt": "2 Std. 15 Min.",
  "schwierigkeit": "normal",
  "kern": "70 bis 75 °C",
  "zutaten": [
   {
    "m": 800,
    "e": "g",
    "t": "Rehkeule ohne Knochen, küchenfertig",
    "teil": "Keule ohne Knochen"
   },
   {
    "m": 1,
    "e": "TL",
    "t": "Wacholderbeeren"
   },
   {
    "m": 0.5,
    "e": "TL",
    "t": "schwarze Pfefferkörner"
   },
   {
    "m": 0.5,
    "e": "TL",
    "t": "Pimentkörner"
   },
   {
    "m": 1.5,
    "e": "EL",
    "t": "Butterschmalz"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "Zwiebel"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "Karotte"
   },
   {
    "m": 1,
    "e": "EL",
    "t": "Tomatenmark"
   },
   {
    "m": 70,
    "e": "g",
    "t": "Backpflaumen"
   },
   {
    "m": 100,
    "e": "ml",
    "t": "Rotwein"
   },
   {
    "m": 270,
    "e": "ml",
    "t": "Wildfond"
   },
   {
    "m": 40,
    "e": "ml",
    "t": "Portwein"
   },
   {
    "m": 70,
    "e": "g",
    "t": "Crème fraîche"
   },
   {
    "m": null,
    "e": "",
    "t": "Speisestärke zum Binden"
   },
   {
    "m": null,
    "e": "",
    "t": "Salz und Pfeffer"
   }
  ],
  "schritte": [
   "Tupf die Keule trocken, salze und pfeffere sie. Zermahle Wacholder, Pfeffer und Piment im Mörser fein und reib das Fleisch rundum damit ein.",
   "Brate die Keule im Bräter in heißem Butterschmalz von allen Seiten kräftig an. Gib fein gewürfelte Zwiebel und Karotte dazu, röste kurz mit und rühre dann das Tomatenmark unter.",
   "Gib die klein geschnittenen Backpflaumen dazu, lösche mit Rotwein ab und gieß den Wildfond an.",
   "Schmor die Keule zugedeckt im vorgeheizten Ofen bei 200 °C (Umluft 180 °C) etwa 1,5 Stunden.",
   "Nimm das Fleisch heraus und halte es warm. Streich den Schmorsud durch ein Sieb, rühre den Portwein ein, lass alles aufkochen und bind die Soße mit etwas angerührter Stärke.",
   "Schmeck mit Salz und Pfeffer ab, rühre die Crème fraîche unter und serviere die Keule in Scheiben mit der Soße."
  ],
  "beilage": "Klassisch festlich mit Rotkohl, Klößen oder Spätzle und Birnenhälften mit Preiselbeeren."
 },
 {
  "id": "hirsch-braten",
  "wild": "rotwild",
  "titel": "Festtags-Hirschbraten in Rotwein-Kirsch-Soße",
  "basis": 4,
  "zeit_arbeit": "30 Min.",
  "zeit_gesamt": "2 Std. 15 Min.",
  "schwierigkeit": "normal",
  "kern": "75 bis 80 °C (geschmort, zart)",
  "zutaten": [
   {
    "m": 1,
    "e": "kg",
    "t": "Hirschkeule ohne Knochen",
    "teil": "Keule ohne Knochen"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "Zwiebel"
   },
   {
    "m": null,
    "e": "",
    "t": "Wildgewürz (Wacholder, Piment, Nelke, Lorbeer)"
   },
   {
    "m": null,
    "e": "",
    "t": "Salz und Pfeffer"
   },
   {
    "m": 3,
    "e": "EL",
    "t": "Öl"
   },
   {
    "m": 170,
    "e": "ml",
    "t": "kräftiger trockener Rotwein"
   },
   {
    "m": 130,
    "e": "ml",
    "t": "Kirschsaft (aus dem Glas)"
   },
   {
    "m": 130,
    "e": "g",
    "t": "Sauerkirschen aus dem Glas, abgetropft"
   },
   {
    "m": 270,
    "e": "ml",
    "t": "Wildfond"
   },
   {
    "m": 70,
    "e": "g",
    "t": "Crème fraîche"
   }
  ],
  "schritte": [
   "Heiz den Ofen auf 200 °C vor. Tupf das Fleisch trocken und würze es mit Salz, Pfeffer und Wildgewürz.",
   "Brate den Braten im ofenfesten Bräter in Öl rundum kräftig an, nimm ihn heraus und röste die gewürfelte Zwiebel im Bratensatz goldbraun.",
   "Gieß Rotwein und Kirschsaft in kleinen Portionen abwechselnd an und lass jede Portion wieder einkochen, bis nur noch etwa ein Drittel der Flüssigkeit übrig ist. So wird die Soße schön dunkel.",
   "Gib den Wildfond dazu, koch alles auf, setz das Fleisch wieder ein und schmor es zugedeckt etwa 90 Minuten im Ofen. Wende es nach der Hälfte der Zeit einmal.",
   "Nimm den Braten heraus, rühre Crème fraîche und Kirschen in die Soße und schmeck sie mit Salz, Pfeffer und Wildgewürz ab."
  ],
  "beilage": "Rotkohl und Knödel machen daraus ein klassisches Weihnachtsessen, als frischen Kontrast reichst du Feldsalat dazu."
 },
 {
  "id": "hirsch-gulasch",
  "wild": "rotwild",
  "titel": "Weihnachtliches Hirschgulasch mit Preiselbeeren und Steinpilzen",
  "basis": 4,
  "zeit_arbeit": "40 Min.",
  "zeit_gesamt": "3 Std. 40 Min.",
  "schwierigkeit": "normal",
  "kern": null,
  "zutaten": [
   {
    "m": 1,
    "e": "kg",
    "t": "Hirschgulasch aus der Keule",
    "teil": "Gulasch aus der Keule"
   },
   {
    "m": 15,
    "e": "g",
    "t": "getrocknete Steinpilze (eine Handvoll)"
   },
   {
    "m": 100,
    "e": "ml",
    "t": "kaltes Wasser zum Einweichen"
   },
   {
    "m": 3,
    "e": "EL",
    "t": "Butterschmalz"
   },
   {
    "m": 200,
    "e": "g",
    "t": "Zwiebeln, klein gewürfelt"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "Möhre, klein gewürfelt"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "kleines Stück Knollensellerie, gewürfelt"
   },
   {
    "m": 1,
    "e": "EL",
    "t": "Tomatenmark"
   },
   {
    "m": 200,
    "e": "ml",
    "t": "trockener Rotwein"
   },
   {
    "m": 400,
    "e": "ml",
    "t": "Wildfond"
   },
   {
    "m": 6,
    "e": "Stk",
    "t": "Wacholderbeeren, angedrückt"
   },
   {
    "m": 3,
    "e": "Stk",
    "t": "Gewürznelken, angedrückt"
   },
   {
    "m": null,
    "e": "",
    "t": "Thymian"
   },
   {
    "m": 1,
    "e": "EL",
    "t": "Rotweinessig oder Aceto balsamico"
   },
   {
    "m": 4,
    "e": "EL",
    "t": "Preiselbeerkompott"
   },
   {
    "m": 1,
    "e": "Prise",
    "t": "Zucker (nach Belieben)"
   },
   {
    "m": 20,
    "e": "g",
    "t": "Lebkuchen ohne Oblate, fein zerbröselt (nach Belieben)"
   },
   {
    "m": null,
    "e": "",
    "t": "Salz und Pfeffer"
   },
   {
    "m": null,
    "e": "",
    "t": "etwas Sahne (nach Belieben)"
   }
  ],
  "schritte": [
   "Weich die Steinpilze eine Stunde in kaltem Wasser ein, drück sie dann aus und hack sie klein. Heb das Einweichwasser auf.",
   "Tupf das Fleisch gut trocken und brate es portionsweise in heißem Butterschmalz scharf an. Nimm es danach wieder heraus.",
   "Brate Zwiebeln, Möhre, Sellerie und Pilze im Bräter an, röste das Tomatenmark kurz mit und lösche nach und nach mit etwa der Hälfte von Rotwein, Fond und Pilzwasser ab.",
   "Gib das Fleisch zurück in den Bräter, würze mit Salz und Pfeffer und füge die restliche Flüssigkeit, Wacholder, Nelken, Thymian, Essig, 2 EL Preiselbeeren und nach Belieben eine Prise Zucker hinzu.",
   "Schmor das Gulasch zugedeckt 2,5 bis 3 Stunden, bis das Fleisch zart ist, und rühre gelegentlich um. Lass den Deckel in der letzten halben Stunde weg, damit die Soße eindickt.",
   "Rühre zum Schluss die übrigen Preiselbeeren unter. Für die weihnachtliche Note kannst du den zerbröselten Lebkuchen einrühren, er bindet die Soße zugleich. Schmeck ab und gib nach Belieben einen Schuss Sahne dazu."
  ],
  "beilage": "Dazu passen Spätzle oder Semmelknödel und ein Apfel-Rotkohl."
 },
 {
  "id": "wildschwein-keule",
  "wild": "wildschwein",
  "titel": "Wildschweinbraten mit Honig und Preiselbeer-Rahmsoße",
  "basis": 4,
  "zeit_arbeit": "25 Min.",
  "zeit_gesamt": "2 Std. 45 Min. + 1 Nacht Marinieren",
  "schwierigkeit": "normal",
  "kern": "mind. 75 °C (durchgegart)",
  "zutaten": [
   {
    "m": 1.2,
    "e": "kg",
    "t": "Wildschweinkeule ohne Schwarte",
    "teil": "Keule ohne Knochen"
   },
   {
    "m": 1.5,
    "e": "TL",
    "t": "getrockneter Rosmarin"
   },
   {
    "m": 1.5,
    "e": "TL",
    "t": "getrockneter Thymian"
   },
   {
    "m": 3,
    "e": "Zehe",
    "t": "Knoblauch, fein gewürfelt"
   },
   {
    "m": 2.5,
    "e": "EL",
    "t": "Sonnenblumenöl"
   },
   {
    "m": null,
    "e": "",
    "t": "Salz und Pfeffer"
   },
   {
    "m": 2,
    "e": "Stk",
    "t": "Zwiebeln, klein gewürfelt"
   },
   {
    "m": 2,
    "e": "Stk",
    "t": "große Karotten, klein gewürfelt"
   },
   {
    "m": 350,
    "e": "ml",
    "t": "trockener Rotwein"
   },
   {
    "m": 400,
    "e": "ml",
    "t": "Wildfond"
   },
   {
    "m": 3,
    "e": "Stk",
    "t": "Tomaten, gehäutet und gewürfelt"
   },
   {
    "m": 4,
    "e": "EL",
    "t": "flüssiger Honig"
   },
   {
    "m": 300,
    "e": "g",
    "t": "Preiselbeeren aus dem Glas"
   },
   {
    "m": 200,
    "e": "ml",
    "t": "Sahne"
   }
  ],
  "schritte": [
   "Reib den Braten mit Salz, Pfeffer, Rosmarin, Thymian, Knoblauch und Öl ein und lass ihn zugedeckt über Nacht im Kühlschrank durchziehen.",
   "Leg das Fleisch mit der Würzmischung, den Zwiebeln und den Karotten in einen großen Bräter und brate alles auf dem Herd rundum scharf an. Wende das Fleisch dabei mehrmals.",
   "Gieß Rotwein und Wildfond an, gib die Tomaten dazu und bestreich die Oberseite des Bratens mit dem Honig.",
   "Schmor den Braten zugedeckt im vorgeheizten Ofen bei 200 °C Ober-/Unterhitze etwa 2 Stunden, bis er zart ist. Wende ihn dabei nicht, damit die Honigschicht oben bleibt.",
   "Nimm das Fleisch heraus und halte es warm. Püriere Schmorgemüse und Bratensaft mit den Preiselbeeren, rühre die Sahne ein, lass die Soße kurz aufkochen und schmeck sie mit Salz ab."
  ],
  "beilage": "Dazu gehören Semmel- oder Brezenknödel und Blaukraut."
 },
 {
  "id": "wildschwein-ruecken",
  "wild": "wildschwein",
  "titel": "Rosa Wildschweinrücken in Wacholder-Orangen-Soße",
  "basis": 4,
  "zeit_arbeit": "1 Std.",
  "zeit_gesamt": "2 Std. + 1 Nacht Marinieren",
  "schwierigkeit": "pfiffig",
  "kern": "58 bis 60 °C (zartrosa)",
  "zutaten": [
   {
    "m": 850,
    "e": "g",
    "t": "Wildschweinrücken, ausgelöst (Lachse)",
    "teil": "Rücken ohne Knochen"
   },
   {
    "m": 2,
    "e": "Zweig",
    "t": "Salbei"
   },
   {
    "m": 2,
    "e": "Zweig",
    "t": "Rosmarin"
   },
   {
    "m": 2,
    "e": "Zweig",
    "t": "Oregano"
   },
   {
    "m": 2,
    "e": "Zweig",
    "t": "Thymian"
   },
   {
    "m": 2,
    "e": "Zehe",
    "t": "Knoblauch, in dünnen Scheiben"
   },
   {
    "m": 2,
    "e": "EL",
    "t": "Olivenöl"
   },
   {
    "m": 1,
    "e": "EL",
    "t": "Butterschmalz zum Anbraten"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "Möhre"
   },
   {
    "m": 50,
    "e": "g",
    "t": "Knollensellerie"
   },
   {
    "m": 1,
    "e": "Stk",
    "t": "kleine Lauchstange"
   },
   {
    "m": 150,
    "e": "ml",
    "t": "Weißwein"
   },
   {
    "m": 20,
    "e": "ml",
    "t": "Wermut (z. B. Noilly Prat)"
   },
   {
    "m": 1,
    "e": "l",
    "t": "Wildfond"
   },
   {
    "m": 10,
    "e": "Stk",
    "t": "Wacholderbeeren"
   },
   {
    "m": 6,
    "e": "Stk",
    "t": "Pimentkörner"
   },
   {
    "m": 6,
    "e": "Stk",
    "t": "schwarze Pfefferkörner"
   },
   {
    "m": 6,
    "e": "Stk",
    "t": "Gewürznelken"
   },
   {
    "m": 1,
    "e": "Prise",
    "t": "Cayennepfeffer"
   },
   {
    "m": 1,
    "e": "TL",
    "t": "abgeriebene Bio-Orangenschale"
   },
   {
    "m": 2,
    "e": "EL",
    "t": "Holunderbeergelee"
   },
   {
    "m": 1.5,
    "e": "EL",
    "t": "Speisestärke"
   },
   {
    "m": 100,
    "e": "ml",
    "t": "Sahne"
   },
   {
    "m": null,
    "e": "",
    "t": "Salz und Pfeffer"
   }
  ],
  "schritte": [
   "Bedeck die Rückenstränge mit den Kräuterzweigen und dem Knoblauch, beträufle sie mit Olivenöl und lass sie in Folie gewickelt einige Stunden oder über Nacht im Kühlschrank ziehen.",
   "Röste Möhre, Sellerie und Lauch grob geschnitten in wenig Öl an, lösche mit Weißwein und Wermut ab und gieß den Wildfond an.",
   "Zerstoß Wacholder, Piment, Pfeffer und Nelken grob im Mörser und gib sie mit Cayenne, Orangenschale und den Marinierkräutern in die Soße. Lass alles etwa 30 Minuten köcheln.",
   "Gieß die Soße durch ein Sieb, bind sie mit angerührter Stärke und schmeck sie mit Salz und Holundergelee ab. Zum Schluss rundest du sie mit der Sahne ab.",
   "Brate das Fleisch rundum scharf an und lass es in einer vorgewärmten Form bei 70 °C im Ofen 40 bis 60 Minuten nachziehen, bis der Kern 58 bis 60 °C hat.",
   "Lösch den Bratensatz mit etwas Soße ab und rühre ihn in die Soße. Schneide den Rücken auf und serviere ihn zartrosa mit der Soße."
  ],
  "beilage": "Semmelknödel und glasierte Maronen oder Rosenkohl machen den Teller festlich."
 },
 {
  "id": "wildfond",
  "wild": "knochen",
  "titel": "Festtags-Wildfond mit Wacholder und Preiselbeeren",
  "basis": 4,
  "zeit_arbeit": "1 Std.",
  "zeit_gesamt": "9 Std.",
  "schwierigkeit": "einfach",
  "kern": null,
  "zutaten": [
   {
    "m": 1.5,
    "e": "kg",
    "t": "Wildknochen und Parüren (Reh, Hirsch, Wildschwein), klein gehackt",
    "teil": "Knochen"
   },
   {
    "m": 30,
    "e": "ml",
    "t": "Öl"
   },
   {
    "m": 2,
    "e": "Stk",
    "t": "Zwiebeln mit Schale, grob zerteilt"
   },
   {
    "m": 1,
    "e": "",
    "t": "Bund Suppengrün, grob zerkleinert"
   },
   {
    "m": 2,
    "e": "TL",
    "t": "Zucker"
   },
   {
    "m": 4,
    "e": "Stk",
    "t": "Pimentkörner"
   },
   {
    "m": 8,
    "e": "Stk",
    "t": "Wacholderbeeren"
   },
   {
    "m": 1,
    "e": "TL",
    "t": "getrockneter Thymian"
   },
   {
    "m": 1,
    "e": "TL",
    "t": "Koriandersaat"
   },
   {
    "m": 3,
    "e": "Blatt",
    "t": "Lorbeer"
   },
   {
    "m": 2,
    "e": "Stk",
    "t": "Gewürznelken"
   },
   {
    "m": 1,
    "e": "TL",
    "t": "schwarze Pfefferkörner"
   },
   {
    "m": 200,
    "e": "ml",
    "t": "kräftiger Rotwein"
   },
   {
    "m": 1,
    "e": "EL",
    "t": "Tomatenmark"
   },
   {
    "m": 2,
    "e": "TL",
    "t": "Senf"
   },
   {
    "m": 2,
    "e": "TL",
    "t": "Preiselbeeren"
   },
   {
    "m": 2,
    "e": "Stk",
    "t": "Tomaten, gewürfelt"
   },
   {
    "m": null,
    "e": "",
    "t": "Salz"
   },
   {
    "m": null,
    "e": "",
    "t": "kaltes Wasser zum Auffüllen"
   }
  ],
  "schritte": [
   "Verteil die Knochen und Parüren auf dem tiefen Backblech, beträufle sie mit Öl und röste sie bei 250 °C in 20 bis 30 Minuten rundum braun.",
   "Gib Zwiebeln und Suppengrün dazu, streu den Zucker darüber und röste alles bei 200 °C etwa 45 Minuten weiter. Gieß zwischendurch immer wieder etwas Wasser an und lass es verdampfen. Beim letzten Angießen kommen die Gewürze dazu.",
   "Verrühre Rotwein, Tomatenmark, Senf und Preiselbeeren, gieß die Mischung mit den Tomaten aufs Blech und lass alles noch 20 bis 30 Minuten rösten.",
   "Füll den gesamten Blechinhalt mit dem Bratensatz in einen großen Topf, bedeck alles knapp mit kaltem Wasser, salze leicht und lass den Fond etwa 2 Stunden ganz leise köcheln. Schöpf dabei den Schaum ab.",
   "Gieß den Fond durch ein Tuch und koch ihn offen auf etwa 1,5 Liter ein. Das kann bis zu 3 Stunden dauern.",
   "Lass den Fond über Nacht abkühlen, heb die feste Fettschicht ab und friere ihn portionsweise ein. Für eine Festtagssoße für 4 Personen reichen etwa 250 ml."
  ],
  "beilage": "Dieser Fond ist die Grundlage für jede Wildsoße und gibt Braten, Gulasch und Jus an den Feiertagen die Tiefe."
 }
];

  /* Mengenrechner: Gramm Rohware pro Person */
  var RECHNER = {
    reh: [['Braten', 'Keule ohne Knochen', 250], ['Rosa gebraten', 'Rücken ohne Knochen', 180], ['Gulasch', 'Gulasch aus der Keule', 200]],
    rotwild: [['Braten', 'Keule ohne Knochen', 250], ['Rosa gebraten', 'Rücken ohne Knochen', 180], ['Gulasch', 'Gulasch aus der Keule', 200]],
    wildschwein: [['Braten', 'Keule mit Knochen', 350], ['Rosa gebraten', 'Rücken ohne Knochen', 180], ['Gulasch', 'Gulasch aus der Keule', 200]]
  };
  var KNOCHEN = { reh: 'Rehknochen', rotwild: 'Hirschknochen', wildschwein: 'Wildschweinknochen' };
  var WILDNAME = { reh: 'Reh', rotwild: 'Rotwild', wildschwein: 'Wildschwein' };

  var WT = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var MON = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var SLOTS_VOLL = ['14 bis 16 Uhr', '16 bis 18 Uhr'];

  function init(root) {
    var form = root.querySelector('#wwb-form');
    if (!form || !form.querySelector('[data-wwb-qty]')) return;
    var cfgEl = root.parentNode.querySelector('script[id^="wwb-config-"]') || document.querySelector('script[id^="wwb-config-"]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    var liste = function (s) { return String(s || '').split(/[\s,]+/).filter(Boolean); };
    var feiertage = liste(cfg.feiertage), halbeTage = liste(cfg.halbeTage);
    var max = cfg.maxKg || 20, versand = cfg.versand || 17, gratisAb = cfg.gratisAb || 300;

    form.noValidate = true;
    var $ = function (s) { return form.querySelector(s); };
    var $$ = function (s) { return [].slice.call(form.querySelectorAll(s)); };
    var qtys = $$('[data-wwb-qty]');
    var eur = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    var kgf = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });
    var zahl = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });
    var list = $('[data-wwb-list]'), empty = $('[data-wwb-empty]'), count = $('[data-wwb-count]');
    var totalRow = $('[data-wwb-total-row]'), totalNote = $('[data-wwb-total-note]'), total = $('[data-wwb-total]');
    var versandZeile = $('[data-wwb-versandzeile]'), versandWert = $('[data-wwb-versand]'), gratisInfo = $('[data-wwb-gratis]');
    var bar = $('[data-wwb-bar]'), msg = $('[data-wwb-msg]');
    var art = 'abholung', personen = 4, termin = null;

    /* ---------- Reiter ---------- */
    var tabs = $$('[data-wwb-tab]'), panels = $$('[data-wwb-panel]'), tableiste = $('.wwb-tabs');
    function zeige(g, scroll) {
      if (!form.querySelector('[data-wwb-panel="' + g + '"]')) return;
      tabs.forEach(function (t) { var an = t.dataset.wwbTab === g; t.setAttribute('aria-selected', an ? 'true' : 'false'); t.tabIndex = an ? 0 : -1; });
      panels.forEach(function (p) { p.hidden = p.dataset.wwbPanel !== g; });
      if (scroll && tableiste.getBoundingClientRect().top < 0) tableiste.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { zeige(t.dataset.wwbTab, true); try { history.replaceState(null, '', '#' + t.dataset.wwbTab); } catch (e) {} });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return; e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); n.click();
      });
    });
    var start = (location.hash || '').replace('#', '');
    zeige(form.querySelector('[data-wwb-panel="' + start + '"]') ? start : (tabs[0] && tabs[0].dataset.wwbTab), false);

    /* ---------- Mengen ---------- */
    function val(i) { var v = parseFloat(String(i.value).replace(',', '.')); return isNaN(v) || v < 0 ? 0 : Math.min(Math.round(v * 2) / 2, max); }
    function finde(g, name) { return qtys.filter(function (i) { return i.dataset.g === g && i.dataset.name === name; })[0]; }
    function setze(i, v, blink) {
      i.value = Math.max(0, Math.min(max, v));
      if (blink) { var row = i.closest('.wwb-pos'); row.classList.remove('is-blink'); void row.offsetWidth; row.classList.add('is-blink'); }
      render();
    }
    function auswahl() {
      return qtys.map(function (i) { return { el: i, kg: val(i), preis: parseFloat(i.dataset.preis) }; }).filter(function (p) { return p.kg > 0; });
    }

    var seite = root.querySelector('.wwb-seite'), seiteSichtbar = false;
    if (seite && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { seiteSichtbar = en[0].isIntersecting; render(); }, { rootMargin: '0px 0px -30% 0px' }).observe(seite);
    }
    /* Seitenspalte ist höher als der Bildschirm: so weit nach oben kleben, dass ihr Ende sichtbar bleibt */
    function klebe() {
      if (!seite || getComputedStyle(seite).position !== 'sticky') return;
      seite.style.top = Math.min(24, window.innerHeight - seite.offsetHeight - 24) + 'px';
    }
    window.addEventListener('resize', klebe);

    function summen() {
      var a = auswahl(), ware = 0, offen = false;
      a.forEach(function (p) { if (isNaN(p.preis)) offen = true; else ware += p.preis * p.kg; });
      var lief = art === 'lieferung' ? (ware >= gratisAb ? 0 : versand) : 0;
      return { a: a, ware: ware, offen: offen, lief: lief, gesamt: ware + lief };
    }

    function render() {
      var s = summen(), jeGruppe = {};
      list.innerHTML = '';
      qtys.forEach(function (i) { i.closest('.wwb-pos').classList.toggle('is-aktiv', val(i) > 0); });
      s.a.forEach(function (p) {
        jeGruppe[p.el.dataset.g] = (jeGruppe[p.el.dataset.g] || 0) + 1;
        var li = document.createElement('li');
        var betrag = isNaN(p.preis) ? null : p.preis * p.kg;
        li.innerHTML = '<span></span><b></b>';
        li.firstChild.textContent = p.el.dataset.name;
        var sm = document.createElement('small'); sm.textContent = p.el.dataset.gruppe + ' · ' + kgf.format(p.kg) + ' kg';
        li.firstChild.appendChild(sm);
        li.lastChild.textContent = betrag === null ? 'auf Anfrage' : eur.format(betrag);
        list.appendChild(li);
      });
      $$('[data-wwb-tabzahl]').forEach(function (z) { var n = jeGruppe[z.dataset.wwbTabzahl] || 0; z.textContent = n; z.hidden = n === 0; });
      var n = s.a.length;
      count.textContent = n + (n === 1 ? ' Position' : ' Positionen');
      empty.hidden = n > 0;
      totalRow.hidden = totalNote.hidden = n === 0;
      versandZeile.hidden = !(art === 'lieferung' && n > 0);
      versandWert.textContent = s.lief === 0 ? 'gratis' : eur.format(s.lief);
      gratisInfo.hidden = !(art === 'lieferung' && n > 0);
      gratisInfo.textContent = s.ware >= gratisAb ? 'Lieferung gratis, dein Warenwert liegt über ' + eur.format(gratisAb) + '.'
        : 'Noch ' + eur.format(gratisAb - s.ware) + ' bis zur kostenlosen Lieferung inkl. Verpackung und Trockeneis.';
      total.textContent = eur.format(s.gesamt) + (s.offen ? ' +' : '');
      if (bar) {
        bar.hidden = n === 0 || seiteSichtbar;
        bar.querySelector('[data-wwb-bar-count]').textContent = n;
        bar.querySelector('[data-wwb-bar-total]').textContent = eur.format(s.gesamt);
      }
      if (n > 0 && msg.dataset.typ === 'leer') msg.hidden = true;
      rechnerZeigen();
      klebe();
    }

    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wwb-plus],[data-wwb-minus]');
      if (!b) return;
      var i = b.parentNode.querySelector('[data-wwb-qty]');
      setze(i, val(i) + (b.hasAttribute('data-wwb-plus') ? 0.5 : -0.5));
    });
    qtys.forEach(function (i) {
      i.addEventListener('input', render);
      i.addEventListener('change', function () { i.value = val(i); render(); });
      i.addEventListener('focus', function () { if (val(i) === 0) i.select(); });
    });

    /* ---------- Mengenrechner ---------- */
    function aufHalbeKg(gramm) { return Math.max(0.5, Math.ceil(gramm / 500) / 2); }
    function rechnerZeigen() {
      $$('[data-wwb-rechner]').forEach(function (box) {
        var g = box.dataset.wwbRechner, ziel = box.querySelector('[data-wwb-vorschlaege]');
        var html = '';
        (RECHNER[g] || []).forEach(function (r, k) {
          var inp = finde(g, r[1]); if (!inp) return;
          var kg = aufHalbeKg(personen * r[2]), drin = val(inp) >= kg;
          html += '<div class="wwb-vorschlag' + (drin ? ' is-drin' : '') + '"><small>' + r[0] + '</small><strong>' + r[1] + '</strong>' +
            '<span class="wwb-vs-menge">' + kgf.format(kg) + ' <span>kg</span></span>' +
            '<button type="button" data-wwb-vs="' + g + '|' + k + '">' + (drin ? 'Ist in deiner Auswahl ✓' : 'In die Auswahl') + '</button></div>';
        });
        ziel.innerHTML = html;
      });
      $$('[data-wwb-personen]').forEach(function (i) { if (document.activeElement !== i) i.value = personen; });
    }
    function setzePersonen(p) {
      personen = Math.max(1, Math.min(60, Math.round(p) || 1));
      render(); rezepteZeigen();
    }
    form.addEventListener('click', function (e) {
      var pb = e.target.closest('[data-wwb-pers]');
      if (pb) { setzePersonen(personen + parseInt(pb.dataset.wwbPers, 10)); return; }
      var vs = e.target.closest('[data-wwb-vs]');
      if (vs) {
        var t = vs.dataset.wwbVs.split('|'), r = RECHNER[t[0]][+t[1]], inp = finde(t[0], r[1]);
        if (inp) setze(inp, aufHalbeKg(personen * r[2]), true);
      }
    });
    $$('[data-wwb-personen]').forEach(function (i) {
      i.addEventListener('input', function () { var v = parseInt(i.value, 10); if (v > 0) setzePersonen(v); });
      i.addEventListener('blur', function () { i.value = personen; });
    });

    /* ---------- Rezepte ---------- */
    function fmtMenge(m, e, f) {
      if (m === null || m === undefined || m === '') return '';
      var x = e === 'Prise' ? m : m * f;
      if (e === 'g' || e === 'ml') {
        if (x >= 1000) return zahl.format(Math.round(x / 100) / 10) + ' ' + (e === 'g' ? 'kg' : 'l');
        return (x < 100 ? Math.round(x / 5) * 5 || 5 : Math.round(x / 10) * 10) + ' ' + e;
      }
      if (e === 'kg' || e === 'l') return zahl.format(Math.round(x * 10) / 10) + ' ' + e;
      var h = Math.max(0.5, Math.round(x * 2) / 2);
      if (e === 'Zehe' || e === 'Blatt' || e === 'Zweig' || (e === 'Stk' && x >= 3)) h = Math.max(1, Math.round(x));
      var txt = h % 1 === 0.5 ? (h === 0.5 ? '½' : Math.floor(h) + '½') : String(h);
      return txt + (e ? ' ' + e : '');
    }
    var REIHE = ['reh', 'rotwild', 'wildschwein'];
    function rezepteFuer(g) {
      if (g === 'alle') return REZEPTE.slice();
      return REZEPTE.filter(function (r) { return r.wild === g || r.wild === 'knochen'; });
    }
    /* Wildart, unter der ein Rezept "läuft" (Fond: gerade offener Reiter, sonst Reh) */
    function wildVon(r) {
      if (r.wild !== 'knochen') return r.wild;
      var offen = panels.filter(function (p) { return !p.hidden; })[0];
      return offen ? offen.dataset.wwbPanel : 'reh';
    }
    function fleischTeil(r, g) {
      var z = r.zutaten.filter(function (z) { return z.teil; })[0];
      if (!z) return null;
      var name = z.teil === 'Knochen' ? KNOCHEN[g] : z.teil;
      return { z: z, name: name, inp: finde(g, name) };
    }
    function faktor(r) { return r.wild === 'knochen' ? 1 : personen / (r.basis || 4); }
    function zutatText(z, r, g) {
      if (r.wild === 'knochen' && z.teil) return KNOCHEN[g] + ' und Parüren, klein gehackt';
      return z.t;
    }
    function portionText(r) { return r.wild === 'knochen' ? 'ergibt ca. 1,5 Liter' : 'für ' + personen + (personen === 1 ? ' Person' : ' Personen'); }
    function wildLabel(r) { return r.wild === 'knochen' ? 'Aus den Knochen' : WILDNAME[r.wild]; }
    function tierUrl(r, hell) { var k = r.wild === 'knochen' ? 'rotwild' : r.wild; return cfg.tiere && cfg.tiere[k + (hell ? '-hell' : '')]; }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function rezept(id) { return REZEPTE.filter(function (r) { return r.id === id; })[0]; }
    function fleischKg(r, g) {
      var ft = fleischTeil(r, g); if (!ft) return 0;
      return aufHalbeKg((ft.z.e === 'kg' ? ft.z.m * 1000 : ft.z.m) * faktor(r));
    }

    /* Band mit allen Rezepten */
    var rzGrid = root.querySelector('[data-wwb-rz-grid]'), rzFilter = 'alle';
    function bandZeigen() {
      if (!rzGrid) return;
      rzGrid.innerHTML = REZEPTE.map(function (r) {
        var t = tierUrl(r, false), bild = cfg.bilder[r.id];
        return '<button type="button" class="wwb-rz-karte" data-wwb-rezept="' + r.id + '" data-wild="' + r.wild + '">' +
          (bild ? '<span class="wwb-rz-bild"><img src="' + bild + '" alt="" loading="lazy" width="900" height="600"></span>'
                : '<span class="wwb-rz-bild wwb-rz-bild--tier"><img src="' + tierUrl(r, true) + '" alt=""></span>') +
          '<span class="wwb-rz-info"><span class="wwb-rz-wild">' + (t ? '<img src="' + t + '" alt="">' : '') + esc(wildLabel(r)) + '</span>' +
          '<h3>' + esc(r.titel) + '</h3><span class="wwb-rz-meta"><span>' + esc(r.zeit_gesamt) + '</span><span>' + esc(r.schwierigkeit) + '</span></span>' +
          '<span class="wwb-rz-mehr">Zum Rezept</span></span></button>';
      }).join('');
      filtern();
    }
    function filtern() {
      [].slice.call(rzGrid.children).forEach(function (k) { k.hidden = !(rzFilter === 'alle' || k.dataset.wild === rzFilter || (k.dataset.wild === 'knochen' && rzFilter !== 'alle')); });
      root.querySelectorAll('[data-wwb-rzf]').forEach(function (b) { b.classList.toggle('is-an', b.dataset.wwbRzf === rzFilter); });
    }
    root.addEventListener('click', function (e) {
      var f = e.target.closest('[data-wwb-rzf]');
      if (f) { rzFilter = f.dataset.wwbRzf; filtern(); return; }
      var z = e.target.closest('[data-wwb-rezepte-zu]');
      if (z) { e.preventDefault(); rzFilter = z.dataset.wwbRezepteZu; filtern(); document.getElementById('wwb-rezepte').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });

    /* Kompakte Liste im Reiter */
    function rezepteZeigen() {
      $$('[data-wwb-rezepte]').forEach(function (box) {
        var g = box.dataset.wwbRezepte;
        box.innerHTML = rezepteFuer(g).map(function (r) {
          return '<button type="button" class="wwb-mini" data-wwb-rezept="' + r.id + '"><img src="' + (cfg.bilder[r.id] || '') + '" alt="" loading="lazy" width="1024" height="688">' +
            '<span>' + esc(r.titel) + '<small>' + esc(r.zeit_gesamt) + ' · ' + esc(portionText(r)) + '</small></span></button>';
        }).join('');
      });
      if (offenesRezept) modalFuellen();
    }

    /* Rezept-Fenster */
    var modal = root.querySelector('[data-wwb-modal]'), modalBox = root.querySelector('[data-wwb-modal-box]');
    var offenesRezept = null, letzterFokus = null;
    function modalFuellen() {
      var r = offenesRezept, g = wildVon(r), f = faktor(r), ft = fleischTeil(r, g), t = tierUrl(r, true), tg = tierUrl(r, false);
      modalBox.innerHTML =
        (cfg.bilder[r.id] ? '<div class="wwb-m-bild"><img src="' + cfg.bilder[r.id] + '" alt="">' : '<div class="wwb-m-bild wwb-m-bild--tier"><img class="wwb-m-tier" src="' + tierUrl(r, true) + '" alt="">') +
        '<button type="button" class="wwb-m-zu" data-wwb-zu aria-label="Schließen"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<div class="wwb-m-kopf"><span class="wwb-rz-wild">' + (t ? '<img src="' + t + '" alt="">' : '') + esc(wildLabel(r)) + '</span><h2 id="wwb-modal-titel">' + esc(r.titel) + '</h2></div></div>' +
        '<div class="wwb-m-leiste"><div class="wwb-m-meta">' +
          '<span><b>Arbeitszeit</b>' + esc(r.zeit_arbeit) + '</span><span><b>Gesamt</b>' + esc(r.zeit_gesamt) + '</span><span><b>Schwierigkeit</b>' + esc(r.schwierigkeit) + '</span>' +
          (r.kern ? '<span><b>Kerntemperatur</b>' + esc(r.kern) + '</span>' : '') + '</div>' +
          (r.wild === 'knochen' ? '<span class="wwb-m-meta"><span><b>Menge</b>ca. 1,5 Liter Fond</span></span>' :
          '<div class="wwb-personen"><button type="button" class="wwb-step" data-wwb-pers="-1" aria-label="Eine Person weniger"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg></button>' +
          '<label><input type="number" min="1" max="60" value="' + personen + '" inputmode="numeric" data-wwb-personen aria-label="Personen"><span>Personen</span></label>' +
          '<button type="button" class="wwb-step" data-wwb-pers="1" aria-label="Eine Person mehr"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button></div>') +
        '</div><div class="wwb-m-inhalt"><div class="wwb-m-zutaten"><h3>Zutaten ' + esc(portionText(r)) + '</h3><ul>' +
          r.zutaten.map(function (z) { return '<li' + (z.teil ? ' class="is-fleisch"' : '') + '><b>' + esc(fmtMenge(z.m, z.e, f)) + '</b><span>' + esc(zutatText(z, r, g)) + '</span></li>'; }).join('') +
        '</ul></div><div class="wwb-m-schritte"><h3>Zubereitung</h3><ol>' + r.schritte.map(function (s) { return '<li><span>' + esc(s) + '</span></li>'; }).join('') + '</ol>' +
          (r.beilage ? '<div class="wwb-m-tipp">' + (tg ? '<img src="' + tg + '" alt="">' : '') + '<span>' + esc(r.beilage) + '</span></div>' : '') +
          '<div class="wwb-m-aktionen" style="margin-top:22px">' +
          (ft && ft.inp ? '<button type="button" class="wwb-btn-fleisch" data-wwb-fleisch="' + r.id + '">' + (r.wild === 'knochen' ? 'Knochen' : 'Fleisch') + ' übernehmen: ' + kgf.format(fleischKg(r, g)) + ' kg ' + esc(ft.name) + '</button>' : '') +
          '<button type="button" class="wwb-btn-pdf" data-wwb-pdf="' + r.id + '">Rezept als PDF</button></div></div></div>';
      // die Personen-Felder im Fenster wie die im Rechner behandeln
      modalBox.querySelectorAll('[data-wwb-personen]').forEach(function (i) {
        i.addEventListener('input', function () { var v = parseInt(i.value, 10); if (v > 0) { personen = Math.min(60, v); render(); rezepteZeigenOhneFenster(); aktualisiereFenster(); } });
      });
    }
    function rezepteZeigenOhneFenster() { var o = offenesRezept; offenesRezept = null; rezepteZeigen(); offenesRezept = o; }
    function aktualisiereFenster() {
      // nur Mengen und Knopftexte neu, damit der Fokus im Personenfeld bleibt
      var r = offenesRezept, g = wildVon(r), f = faktor(r), ft = fleischTeil(r, g);
      modalBox.querySelectorAll('.wwb-m-zutaten li b').forEach(function (b, k) { b.textContent = fmtMenge(r.zutaten[k].m, r.zutaten[k].e, f); });
      var h = modalBox.querySelector('.wwb-m-zutaten h3'); if (h) h.textContent = 'Zutaten ' + portionText(r);
      var fb = modalBox.querySelector('[data-wwb-fleisch]'); if (fb && ft) fb.textContent = 'Fleisch übernehmen: ' + kgf.format(fleischKg(r, g)) + ' kg ' + ft.name;
    }
    function oeffneRezept(id) {
      offenesRezept = rezept(id); if (!offenesRezept) return;
      letzterFokus = document.activeElement;
      modalFuellen();
      modal.hidden = false; document.documentElement.classList.add('wwb-modal-offen');
      modalBox.scrollTop = 0;
      var zu = modalBox.querySelector('.wwb-m-zu'); if (zu) zu.focus();
    }
    function schliesse() {
      modal.hidden = true; offenesRezept = null; document.documentElement.classList.remove('wwb-modal-offen');
      if (letzterFokus && letzterFokus.focus) letzterFokus.focus();
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) schliesse(); });

    root.addEventListener('click', function (e) {
      var k = e.target.closest('[data-wwb-rezept]');
      if (k) { oeffneRezept(k.dataset.wwbRezept); return; }
      if (e.target.closest('[data-wwb-zu]')) { schliesse(); return; }
      if (!modal.hidden && e.target.closest('[data-wwb-modal] [data-wwb-pers]')) {
        var pb = e.target.closest('[data-wwb-pers]');
        personen = Math.max(1, Math.min(60, personen + parseInt(pb.dataset.wwbPers, 10)));
        render(); rezepteZeigenOhneFenster(); aktualisiereFenster();
        var inp = modalBox.querySelector('[data-wwb-personen]'); if (inp) inp.value = personen;
        return;
      }
      var fb = e.target.closest('[data-wwb-fleisch]');
      if (fb) {
        var r = rezept(fb.dataset.wwbFleisch), g = wildVon(r), ft = fleischTeil(r, g);
        if (ft && ft.inp) {
          zeige(g, false);
          setze(ft.inp, Math.max(val(ft.inp), fleischKg(r, g)), true);
          fb.textContent = kgf.format(val(ft.inp)) + ' kg ' + ft.name + ' ist in deiner Auswahl ✓';
        }
        return;
      }
      var pdfb = e.target.closest('[data-wwb-pdf]');
      if (pdfb) { pdf([rezept(pdfb.dataset.wwbPdf)], pdfb, false); return; }
      var ab = e.target.closest('[data-wwb-alle-pdf]');
      if (ab) pdf(rezepteFuer(ab.dataset.wwbAllePdf), ab, true, ab.dataset.wwbAllePdf);
    });

    /* ---------- PDF ---------- */
    var libs = null;
    function lade(src) {
      return new Promise(function (ok, fail) { var s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = fail; document.head.appendChild(s); });
    }
    function ladeLibs() {
      if (!libs) libs = Promise.all([
        lade('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js'),
        lade('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js')
      ]);
      return libs;
    }
    function tierReihe(hell) {
      return ['reh', 'rotwild', 'wildschwein', 'fasan'].map(function (k) {
        var u = cfg.tiere && cfg.tiere[k + (hell ? '-hell' : '')]; return u ? '<img class="t-' + k + '" src="' + u + '" alt="">' : '';
      }).join('');
    }
    function pdfFuss() {
      return '<div class="p-fuss"><div class="p-tiere">' + tierReihe(true) + '</div><div class="p-fuss-text"><div><b>Das Wild dazu</b> aus eigener Jagd, im Haus zerlegt und vakuumiert.<br>Vorbestellen: hunters-world.store/pages/weihnachts-wild</div>' +
        '<div class="p-fuss-r">' + esc(cfg.adresse) + '<br>' + esc(cfg.telefon) + ' · ' + esc(cfg.mail) + '</div></div></div>';
    }
    function pdfSeite(r, nr) {
      var g = wildVon(r), f = faktor(r), t = tierUrl(r, true), tg = tierUrl(r, false);
      var el = document.createElement('div');
      el.className = 'wwb-pdf';
      el.innerHTML =
        (cfg.bilder[r.id] ? '<div class="p-bild" style="background-image:url(' + cfg.bilder[r.id] + ')"><div class="p-verlauf"></div>'
                          : '<div class="p-bild p-bild--tier"><img class="p-tier" src="' + tierUrl(r, true) + '" alt=""><div class="p-verlauf"></div>') +
          '<div class="p-oben"><img class="p-logo" src="' + (cfg.logoWeiss || cfg.logo) + '" alt=""><span>Festtagsrezepte 2026' + (nr ? ' · ' + nr : '') + '</span></div>' +
          '<div class="p-titel"><span class="p-wild">' + (t ? '<img src="' + t + '" alt="">' : '') + esc(wildLabel(r)) + '</span><h1>' + esc(r.titel) + '</h1></div></div>' +
        '<div class="p-meta"><div><b>Menge</b>' + esc(portionText(r).replace(/^f/, 'F').replace(/^e/, 'E')) + '</div><div><b>Arbeitszeit</b>' + esc(r.zeit_arbeit) + '</div><div><b>Gesamt</b>' + esc(r.zeit_gesamt) + '</div>' +
          '<div><b>' + (r.kern ? 'Kerntemperatur' : 'Schwierigkeit') + '</b>' + esc(r.kern || r.schwierigkeit) + '</div></div>' +
        '<div class="p-spalten"><div class="p-zutaten"><h2>Zutaten</h2><ul>' + r.zutaten.map(function (z) {
          return '<li' + (z.teil ? ' class="f"' : '') + '><b>' + esc(fmtMenge(z.m, z.e, f)) + '</b><span>' + esc(zutatText(z, r, g)) + '</span></li>';
        }).join('') + '</ul>' + (tg ? '<img class="p-wasser" src="' + tg + '" alt="">' : '') + '</div><div class="p-schritte"><h2>Zubereitung</h2><ol>' +
        r.schritte.map(function (s, k) { return '<li><em>' + (k + 1) + '</em><span>' + esc(s) + '</span></li>'; }).join('') + '</ol>' +
        (r.beilage ? '<div class="p-tipp"><b>Dazu passt</b>' + esc(r.beilage.replace(/^Dazu (passt|passen|gehören):?\s*/i, '')) + '</div>' : '') + '</div></div>' +
        pdfFuss();
      return el;
    }
    function pdfDeckblatt(rezepte) {
      var el = document.createElement('div');
      el.className = 'wwb-pdf wwb-pdf--deck';
      el.innerHTML =
        '<div class="d-collage">' + (cfg.deck || []).slice(0, 3).map(function (u) { return '<div style="background-image:url(' + u + ')"></div>'; }).join('') + '<div class="d-verlauf"></div></div>' +
        '<div class="d-inhalt"><img class="d-logo" src="' + (cfg.logoWeiss || cfg.logo) + '" alt="">' +
        '<span class="d-eyebrow">Weihnachten 2026</span><h1>Festtagsrezepte<br>mit Wild.</h1>' +
        '<p class="d-sub">Aus eigener Jagd, im Haus zerlegt. Mengen ' + (personen === 1 ? 'für 1 Person' : 'für ' + personen + ' Personen') + '.</p>' +
        '<div class="d-tiere">' + tierReihe(true) + '</div>' +
        '<ol class="d-liste">' + rezepte.map(function (r, k) { return '<li><span>' + esc(wildLabel(r)) + '</span>' + esc(r.titel) + '<i>' + (k + 2) + '</i></li>'; }).join('') + '</ol></div>' +
        '<div class="d-fuss">' + esc(cfg.adresse) + ' · ' + esc(cfg.telefon) + ' · hunters-world.store</div>';
      return el;
    }
    var PDF_CSS = '.wwb-pdf{--s:1;--bh:420px;width:794px;height:1123px;background:#f4efe6;color:#2c3322;font-family:Inter,"Helvetica Neue",Arial,sans-serif;position:relative;overflow:hidden;box-sizing:border-box}' +
      '.wwb-pdf *{box-sizing:border-box;margin:0;padding:0}' +
      '.wwb-pdf .p-bild{position:relative;height:var(--bh);background-size:cover;background-position:center}' +
      '.wwb-pdf .p-bild--tier{background:radial-gradient(90% 120% at 82% 75%,#3a4430 0%,#2c3322 65%)}' +
      '.wwb-pdf .p-tier{position:absolute;right:56px;top:50%;transform:translateY(-46%);height:58%;width:auto;opacity:.95}' +
      '.wwb-pdf .p-bild--tier .p-verlauf{background:linear-gradient(0deg,rgba(18,21,19,.55) 0%,rgba(18,21,19,0) 55%)}' +
      '.wwb-pdf .p-verlauf{position:absolute;inset:0;background:linear-gradient(0deg,rgba(18,21,19,.92) 0%,rgba(18,21,19,.25) 48%,rgba(18,21,19,.55) 100%)}' +
      '.wwb-pdf .p-oben{position:absolute;left:48px;right:48px;top:28px;display:flex;justify-content:space-between;align-items:center;color:#e9e4d8;font-size:11px;letter-spacing:3px;text-transform:uppercase;font-weight:600}' +
      '.wwb-pdf .p-logo{height:52px;width:auto}' +
      '.wwb-pdf .p-titel{position:absolute;left:48px;right:48px;bottom:30px;color:#fff}' +
      '.wwb-pdf .p-wild{display:flex;align-items:center;gap:10px;font-size:12px;letter-spacing:3px;text-transform:uppercase;color:#c9d3a6;font-weight:700;margin-bottom:12px}' +
      '.wwb-pdf .p-wild img{height:30px;width:auto}' +
      '.wwb-pdf h1{font-size:calc(38px * var(--s));line-height:1.08;letter-spacing:-.6px;font-weight:700}' +
      '.wwb-pdf .p-meta{display:grid;grid-template-columns:repeat(4,1fr);margin:0 48px;border-bottom:1.5px solid #2c3322}' +
      '.wwb-pdf .p-meta div{padding:14px 12px 13px 0;font-size:13px;color:#3b3f34;border-right:1px solid rgba(44,51,34,.15);padding-left:14px}' +
      '.wwb-pdf .p-meta div:first-child{padding-left:0}.wwb-pdf .p-meta div:last-child{border-right:0}' +
      '.wwb-pdf .p-meta b{display:block;font-size:9.5px;letter-spacing:2px;text-transform:uppercase;color:#5e6e37;margin-bottom:3px}' +
      '.wwb-pdf .p-spalten{display:grid;grid-template-columns:262px 1fr;gap:32px;padding:22px 48px 0}' +
      '.wwb-pdf h2{font-size:11px;letter-spacing:3px;text-transform:uppercase;font-weight:700;margin-bottom:10px;color:#5e6e37}' +
      '.wwb-pdf .p-zutaten{position:relative;background:#ebe4d5;padding:18px 18px 16px;align-self:start;overflow:hidden}' +
      '.wwb-pdf .p-zutaten ul{list-style:none;position:relative;z-index:1}' +
      '.wwb-pdf .p-zutaten li{display:grid;grid-template-columns:64px 1fr;gap:8px;font-size:calc(12.5px * var(--s));line-height:1.35;padding:calc(4.5px * var(--s)) 0;border-bottom:1px solid rgba(44,51,34,.1)}' +
      '.wwb-pdf .p-zutaten li:last-child{border-bottom:0}' +
      '.wwb-pdf .p-zutaten li b{font-weight:700;text-align:right}' +
      '.wwb-pdf .p-zutaten li.f span{font-weight:700;color:#4b5a2b}' +
      '.wwb-pdf .p-wasser{position:absolute;right:-18px;bottom:-10px;width:150px;height:auto;opacity:.12}' +
      '.wwb-pdf .p-schritte ol{list-style:none}' +
      '.wwb-pdf .p-schritte li{display:grid;grid-template-columns:28px 1fr;gap:12px;font-size:calc(13px * var(--s));line-height:1.55;margin-bottom:calc(10px * var(--s))}' +
      '.wwb-pdf .p-schritte em{font-style:normal;width:26px;height:26px;border-radius:50%;background:#2c3322;color:#f4efe6;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:center}' +
      '.wwb-pdf .p-tipp{margin-top:12px;font-size:calc(12.5px * var(--s));line-height:1.5;padding:12px 14px;border-left:3px solid #5e6e37;background:rgba(94,110,55,.08)}' +
      '.wwb-pdf .p-tipp b{display:block;font-size:9.5px;letter-spacing:2px;text-transform:uppercase;color:#5e6e37;margin-bottom:3px}' +
      '.wwb-pdf .p-fuss{position:absolute;left:0;right:0;bottom:0;background:#2c3322;color:#e9e4d8;padding:0 48px 16px}' +
      '.wwb-pdf .p-tiere{display:flex;align-items:flex-end;gap:22px;height:46px;transform:translateY(-22px);margin-bottom:-14px}' +
      '.wwb-pdf .p-tiere img{height:40px;width:auto}.wwb-pdf .p-tiere .t-rotwild{height:48px}.wwb-pdf .p-tiere .t-wildschwein{height:30px}.wwb-pdf .p-tiere .t-fasan{height:26px}' +
      '.wwb-pdf .p-fuss-text{display:flex;justify-content:space-between;gap:24px;font-size:10.5px;line-height:1.55}' +
      '.wwb-pdf .p-fuss-r{text-align:right}' +
      /* Deckblatt */
      '.wwb-pdf--deck{background:#1f2620;color:#f4efe6}' +
      '.wwb-pdf .d-collage{position:absolute;inset:0 0 auto 0;height:520px;display:grid;grid-template-columns:1.4fr 1fr;grid-template-rows:1fr 1fr;gap:4px}' +
      '.wwb-pdf .d-collage div{background-size:cover;background-position:center}' +
      '.wwb-pdf .d-collage div:first-child{grid-row:span 2}' +
      '.wwb-pdf .d-collage div:nth-child(4){display:none}' +
      '.wwb-pdf .d-verlauf{position:absolute;inset:0;background:linear-gradient(0deg,#1f2620 0%,rgba(31,38,32,.2) 55%,rgba(31,38,32,.35) 100%)}' +
      '.wwb-pdf .d-inhalt{position:absolute;left:56px;right:56px;top:300px}' +
      '.wwb-pdf .d-logo{height:70px;width:auto;margin-bottom:26px}' +
      '.wwb-pdf .d-eyebrow{display:block;font-size:13px;letter-spacing:5px;text-transform:uppercase;color:#c9d3a6;font-weight:600;margin-bottom:12px}' +
      '.wwb-pdf--deck h1{font-size:62px;line-height:1;letter-spacing:-1.5px;margin-bottom:16px}' +
      '.wwb-pdf .d-sub{font-size:16px;color:#d9d8d2;margin-bottom:26px}' +
      '.wwb-pdf .d-tiere{display:flex;align-items:flex-end;gap:26px;padding-bottom:10px;border-bottom:1.5px solid rgba(201,211,166,.45);margin-bottom:22px}' +
      '.wwb-pdf .d-tiere img{height:52px;width:auto}.wwb-pdf .d-tiere .t-rotwild{height:64px}.wwb-pdf .d-tiere .t-wildschwein{height:40px}.wwb-pdf .d-tiere .t-fasan{height:34px}' +
      '.wwb-pdf .d-liste{list-style:none}' +
      '.wwb-pdf .d-liste li{display:grid;grid-template-columns:140px 1fr 30px;align-items:baseline;gap:12px;padding:9px 0;border-bottom:1px solid rgba(217,216,210,.14);font-size:15px}' +
      '.wwb-pdf .d-liste span{font-size:10.5px;letter-spacing:2px;text-transform:uppercase;color:#c9d3a6;font-weight:700}' +
      '.wwb-pdf .d-liste i{font-style:normal;text-align:right;color:#9aa08f;font-size:13px}' +
      '.wwb-pdf .d-fuss{position:absolute;left:56px;right:56px;bottom:30px;font-size:11px;color:#9aa08f;letter-spacing:1px}';

    function pdf(rezepte, knopf, mitDeckblatt, g) {
      if (!rezepte.length || !rezepte[0]) return;
      var alt = knopf.innerHTML;
      knopf.disabled = true; knopf.textContent = 'PDF wird erstellt …';
      var buehne = document.createElement('div');
      buehne.setAttribute('aria-hidden', 'true');
      buehne.style.cssText = 'position:fixed;left:-10000px;top:0;z-index:-1';
      buehne.innerHTML = '<style>' + PDF_CSS + '</style>';
      document.body.appendChild(buehne);
      var seiten = [];
      if (mitDeckblatt && rezepte.length > 1) { var d = pdfDeckblatt(rezepte); buehne.appendChild(d); seiten.push(d); }
      rezepte.forEach(function (r, k) { var s = pdfSeite(r, mitDeckblatt && rezepte.length > 1 ? 'Seite ' + (k + 2) : ''); buehne.appendChild(s); seiten.push(s); });
      var bilderGeladen = Promise.all([].slice.call(buehne.querySelectorAll('img')).map(function (im) {
        return im.complete ? 1 : new Promise(function (ok) { im.onload = im.onerror = ok; });
      }).concat(rezepte.map(function (r) { return cfg.bilder[r.id]; }).concat(cfg.deck || []).filter(Boolean).map(function (u) {
        return new Promise(function (ok) { var im = new Image(); im.onload = im.onerror = ok; im.src = u; });
      })));
      Promise.all([ladeLibs(), bilderGeladen, document.fonts ? document.fonts.ready : 1]).then(function () {
        /* Lange Rezepte passend machen: erst das Foto flacher, dann die Schrift kleiner */
        seiten.forEach(function (s) {
          var spalten = s.querySelector('.p-spalten'), fuss = s.querySelector('.p-fuss');
          if (!spalten) return;
          var passt = function () { return spalten.offsetTop + spalten.offsetHeight <= fuss.offsetTop - 18; };
          var bh = 420, sc = 1;
          while (!passt() && bh > 230) { bh -= 20; s.style.setProperty('--bh', bh + 'px'); }
          while (!passt() && sc > 0.74) { sc -= 0.03; s.style.setProperty('--s', sc.toFixed(2)); }
        });
        var doc = new window.jspdf.jsPDF({ unit: 'pt', format: 'a4', compress: true });
        var kette = Promise.resolve();
        seiten.forEach(function (s, k) {
          kette = kette.then(function () {
            return window.html2canvas(s, { scale: 2, useCORS: true, backgroundColor: null, logging: false }).then(function (c) {
              if (k > 0) doc.addPage();
              doc.addImage(c.toDataURL('image/jpeg', 0.9), 'JPEG', 0, 0, 595.28, 841.89);
            });
          });
        });
        return kette.then(function () {
          var name = rezepte.length === 1 ? rezepte[0].id : 'Festtagsrezepte' + (g && g !== 'alle' ? '-' + g : '');
          doc.save('Hunters-World-' + name + (rezepte.length === 1 && rezepte[0].wild === 'knochen' ? '' : '-' + personen + '-Personen') + '.pdf');
        });
      }).catch(function () {
        alert('Das PDF konnte gerade nicht erstellt werden. Bitte versuch es noch einmal.');
      }).then(function () {
        buehne.remove(); knopf.disabled = false; knopf.innerHTML = alt;
      });
    }

    /* ---------- Öffnungszeiten, Feiertage, Kalender ---------- */
    function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
    function plusTage(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
    /* null = geschlossen, 'voll' = 10 bis 13 und 14 bis 18 Uhr, 'halb' = nur vormittags */
    function oeffnung(d) {
      var s = iso(d), wt = d.getDay(), z;
      if (feiertage.indexOf(s) > -1) return null;
      if (s < '2026-11-01') z = [null, null, 'voll', 'voll', 'voll', 'voll', 'halb'][wt];      // bis 31.10.: Mo Ruhetag
      else z = [null, 'voll', 'voll', 'halb', 'voll', 'voll', 'halb'][wt];                     // ab 1.11.: Mi nur vormittags
      if (z && halbeTage.indexOf(s) > -1) z = 'halb';
      return z;
    }
    var heute = new Date(); heute = new Date(heute.getFullYear(), heute.getMonth(), heute.getDate());
    var bis = cfg.bis ? new Date(cfg.bis + 'T00:00:00') : plusTage(heute, 90);
    function frei(d) {
      if (d > bis) return false;
      if (art === 'abholung') return d >= plusTage(heute, cfg.vorlaufAbholung || 2) && !!oeffnung(d);
      var wt = d.getDay();
      if (d < plusTage(heute, cfg.vorlaufLieferung || 3) || wt < 2 || wt > 5) return false;  // Zustellung Di bis Fr
      return feiertage.indexOf(iso(d)) === -1 && feiertage.indexOf(iso(plusTage(d, -1))) === -1; // Versandtag kein Feiertag
    }
    var kal = $('[data-wwb-kalender]'), kalMonat = null;
    function ersterFreier() { for (var d = plusTage(heute, 1); d <= bis; d = plusTage(d, 1)) if (frei(d)) return d; return null; }
    function kalender() {
      var erster = ersterFreier();
      if (!kalMonat) kalMonat = erster ? new Date(erster.getFullYear(), erster.getMonth(), 1) : new Date(heute.getFullYear(), heute.getMonth(), 1);
      var minM = erster ? new Date(erster.getFullYear(), erster.getMonth(), 1) : kalMonat, maxM = new Date(bis.getFullYear(), bis.getMonth(), 1);
      if (kalMonat < minM) kalMonat = minM;
      if (kalMonat > maxM) kalMonat = maxM;
      var y = kalMonat.getFullYear(), m = kalMonat.getMonth();
      var h = '<div class="wwb-kal-kopf"><button type="button" data-kal="-1" aria-label="Vorheriger Monat"' + (kalMonat <= minM ? ' disabled' : '') + '><svg viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg></button>' +
        '<strong>' + MON[m] + ' ' + y + '</strong><button type="button" data-kal="1" aria-label="Nächster Monat"' + (kalMonat >= maxM ? ' disabled' : '') + '><svg viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"/></svg></button></div><div class="wwb-kal-raster">';
      ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].forEach(function (w) { h += '<span class="wwb-kal-wt">' + w + '</span>'; });
      var leer = (new Date(y, m, 1).getDay() + 6) % 7;
      for (var k = 0; k < leer; k++) h += '<span></span>';
      var tage = new Date(y, m + 1, 0).getDate();
      for (var t = 1; t <= tage; t++) {
        var d = new Date(y, m, t), s = iso(d), ok = frei(d), o = oeffnung(d);
        var cls = 'wwb-kal-tag' + (ok ? ' is-frei' : '') + (ok && art === 'abholung' && o === 'halb' ? ' is-halb' : '') +
          (feiertage.indexOf(s) > -1 ? ' is-feiertag' : '') + (termin && iso(termin) === s ? ' is-gewaehlt' : '');
        var label = WT[d.getDay()] + ', ' + t + '. ' + MON[m] + (feiertage.indexOf(s) > -1 ? ', Feiertag' : ok ? '' : ', nicht möglich');
        h += ok ? '<button type="button" class="' + cls + '" data-tag="' + s + '" aria-label="' + label + '" aria-pressed="' + (termin && iso(termin) === s) + '">' + t + '</button>'
                : '<span class="' + cls + '" aria-label="' + label + '">' + t + '</span>';
      }
      h += '</div><div class="wwb-kal-legende">' + (art === 'abholung' ? '<span><i></i>nur bis 13 Uhr</span>' : '<span>Zustellung dienstags bis freitags</span>') + '<span><s>25</s>Feiertag, geschlossen</span></div>';
      kal.innerHTML = h;
    }
    kal.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-kal]');
      if (nav) { kalMonat = new Date(kalMonat.getFullYear(), kalMonat.getMonth() + parseInt(nav.dataset.kal, 10), 1); kalender(); return; }
      var b = e.target.closest('[data-tag]');
      if (!b) return;
      termin = new Date(b.dataset.tag + 'T00:00:00');
      kal.classList.remove('wwb-invalid');
      kalender(); zeiten();
    });
    var zeitSel = $('[data-wwb-zeit]'), zeitenInfo = $('[data-wwb-zeiten-info]');
    function zeiten() {
      var o = termin ? oeffnung(termin) : null, opts;
      $('[data-wwb-termin]').value = termin ? WT[termin.getDay()] + ', ' + termin.getDate() + '. ' + MON[termin.getMonth()] + ' ' + termin.getFullYear() : '';
      if (art === 'lieferung') {
        zeitenInfo.textContent = termin ? 'Zustellung am ' + $('[data-wwb-termin]').value + ', im Lauf des Tages, gekühlt mit Trockeneis.' : 'Wähle deinen Wunschtag für die Zustellung.';
        return;
      }
      if (!termin) { zeitSel.innerHTML = '<option value="">Bitte erst einen Tag wählen</option>'; zeitenInfo.textContent = 'Frisch zugeschnitten und abholbereit ab 12 Uhr.'; return; }
      opts = o === 'halb' ? ['12 bis 13 Uhr'] : ['Egal, ab 12 Uhr', '12 bis 13 Uhr'].concat(SLOTS_VOLL);
      zeitSel.innerHTML = opts.map(function (x) { return '<option>' + x + '</option>'; }).join('');
      zeitenInfo.textContent = o === 'halb' ? 'An diesem Tag haben wir nur vormittags geöffnet, Abholung von 12 bis 13 Uhr.' : 'Abholbereit ab 12 Uhr, geöffnet bis 18 Uhr.';
    }

    /* ---------- Abholung oder Lieferung ---------- */
    var plzInfo = $('[data-wwb-plz-info]'), plzFeld = $('[data-wwb-plz]');
    var plzMuster = PLZ.split(',').map(function (p) { return p.trim(); });
    function plzOk(p) {
      if (!/^\d{5}$/.test(p)) return null;
      return plzMuster.some(function (m) { return m.slice(-1) === '*' ? p.indexOf(m.slice(0, -1)) === 0 : p === m; });
    }
    function pruefePlz() {
      var r = plzOk(plzFeld.value.trim());
      plzInfo.hidden = r === null;
      if (r === null) return;
      plzInfo.classList.toggle('is-raus', !r);
      plzInfo.textContent = r ? 'Wir liefern zu dir, mit Trockeneis gekühlt.' : 'Diese Postleitzahl liegt leider außerhalb unseres Liefergebiets von 100 km. Hol dein Wild gern bei uns im Geschäft ab.';
    }
    plzFeld.addEventListener('input', pruefePlz);
    function setzeArt(a) {
      art = a;
      $$('[data-wwb-nur]').forEach(function (el) { el.hidden = el.dataset.wwbNur !== art; });
      $$('[data-wwb-pflicht-lieferung]').forEach(function (el) { el.disabled = art !== 'lieferung'; el.required = art === 'lieferung'; });
      zeitSel.disabled = art !== 'abholung';
      var vorort = $('[data-wwb-zahl-vorort]'), online = $('[data-wwb-zahl-online]');
      vorort.disabled = art === 'lieferung';
      if (art === 'lieferung') online.checked = true;
      $('[data-wwb-online-text]').textContent = art === 'lieferung'
        ? 'Bei Lieferung zahlst du vorab online, den Zahlungslink bekommst du mit der Bestätigung.'
        : 'Du bekommst mit der Bestätigung einen Zahlungslink.';
      $('[data-wwb-tag-titel]').textContent = art === 'lieferung' ? 'Liefertag' : 'Abholtag';
      if (termin && !frei(termin)) termin = null;
      kalender(); zeiten(); render();
    }
    $$('[data-wwb-art]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) setzeArt(r.dataset.wwbArt); }); });

    /* ---------- Absenden ---------- */
    function fehler(text, el, typ) {
      msg.textContent = text; msg.hidden = false; msg.dataset.typ = typ || '';
      if (el) { el.classList.add('wwb-invalid'); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (el.focus && el.tagName !== 'DIV') el.focus({ preventScroll: true }); }
    }
    form.addEventListener('input', function (e) { if (e.target.classList) e.target.classList.remove('wwb-invalid'); });

    form.addEventListener('submit', function (e) {
      var s = summen();
      $$('.wwb-invalid').forEach(function (el) { el.classList.remove('wwb-invalid'); });
      if (!s.a.length) { e.preventDefault(); fehler('Bitte wähle mindestens ein Teilstück aus.', tableiste, 'leer'); return; }
      if (art === 'lieferung') {
        var felder = $$('[data-wwb-pflicht-lieferung]');
        for (var j = 0; j < felder.length; j++) if (!felder[j].value.trim()) { e.preventDefault(); fehler('Bitte gib deine Lieferadresse vollständig an.', felder[j]); return; }
        if (!plzOk(plzFeld.value.trim())) { e.preventDefault(); fehler('Diese Postleitzahl liegt außerhalb unseres Liefergebiets von 100 km. Wähle bitte Abholung.', plzFeld); return; }
      }
      if (!termin) { e.preventDefault(); fehler(art === 'lieferung' ? 'Bitte wähle einen Liefertag.' : 'Bitte wähle einen Abholtag.', kal); return; }
      var pflicht = $$('.wwb-kontakt [required]');
      for (var k = 0; k < pflicht.length; k++) {
        var f = pflicht[k];
        if (!f.checkValidity()) {
          e.preventDefault();
          fehler(f.type === 'checkbox' ? 'Bitte bestätige den Hinweis zum Datenschutz.' : f.type === 'email' ? 'Bitte gib eine gültige E-Mail-Adresse an.' : 'Bitte fülle alle Pflichtfelder aus.', f.type === 'checkbox' ? f.parentNode : f);
          return;
        }
      }
      /* Mailtext: Shopify schickt alle Formularfelder mit. Damit die Mail lesbar bleibt, steht alles
         geordnet im Textfeld, und nur Name, E-Mail, Telefon und dieser Text werden übertragen. */
      var wert = function (sel) { var el = form.querySelector(sel); return el ? el.value.trim() : ''; };
      var zahlung = form.querySelector('[name="contact[Zahlung]"]:checked');
      var online = zahlung && zahlung.hasAttribute('data-wwb-zahl-online');
      var pos = s.a.map(function (p) {
        var b = isNaN(p.preis) ? null : p.preis * p.kg;
        return kgf.format(p.kg) + ' kg ' + p.el.dataset.gruppe + ', ' + p.el.dataset.name + (b === null ? ' (Preis auf Anfrage)' : ' (' + eur.format(p.preis) + '/kg) ca. ' + eur.format(b));
      });
      var t = ['VORBESTELLUNG WEIHNACHTSWILD, bitte bestätigen', '',
        'KONTAKT', wert('[name="contact[name]"]'), wert('[name="contact[Telefon]"]'), wert('[name="contact[email]"]'), '',
        'BESTELLUNG'].concat(pos).concat(['',
        'PREIS', 'Warenwert ca. ' + eur.format(s.ware) + (s.offen ? ' zzgl. Positionen auf Anfrage' : '')]);
      if (art === 'lieferung') t.push('Versand inkl. Verpackung und Trockeneis: ' + (s.lief ? eur.format(s.lief) : 'gratis'));
      t.push('Gesamt ca. ' + eur.format(s.gesamt) + ' (nach Gewicht)', '');
      t.push(art === 'lieferung' ? 'LIEFERUNG mit Trockeneis' : 'ABHOLUNG im Geschäft');
      t.push(wert('[data-wwb-termin]') + (art === 'abholung' ? ', ' + zeitSel.value : ''));
      if (art === 'lieferung') t.push(wert('[name="contact[Straße und Hausnummer]"]') + ', ' + wert('[name="contact[PLZ]"]') + ' ' + wert('[name="contact[Ort]"]'));
      t.push('Zahlung: ' + (online ? 'online, Zahlungslink mit der Bestätigung schicken' : 'bei Abholung (bar oder Karte)'));
      var anm = wert('[name="contact[Anmerkung]"]');
      if (anm) t.push('', 'ANMERKUNG', anm);
      $('[data-wwb-body]').value = t.join('\n');
      speichere();
      var aus = $$('input[name^="contact["], textarea[name^="contact["], select[name^="contact["]').filter(function (el) {
        return ['contact[name]', 'contact[email]', 'contact[Telefon]', 'contact[body]'].indexOf(el.name) === -1 && !el.disabled;
      });
      aus.forEach(function (el) { el.disabled = true; });
      var sb = form.querySelector('.wwb-submit'); sb.disabled = true; sb.textContent = 'Wird gesendet …';
      /* Bricht die Sicherheitsabfrage von Shopify ab, bleibt die Seite stehen: Formular wieder freigeben */
      setTimeout(function () { aus.forEach(function (el) { el.disabled = false; }); setzeArt(art); sb.disabled = false; sb.textContent = 'Vorbestellung absenden'; }, 8000);
    });

    /* ---------- Entwurf merken ----------
       Lehnt Shopify das Absenden ab (Pflichtangabe, Sicherheitsabfrage), lädt die Seite neu.
       Damit die Auswahl dabei nicht verloren geht, liegt sie im sessionStorage des Browsers. */
    var SPEICHER = 'wwb-entwurf-v1';
    function speichere() {
      try {
        var d = { q: {}, f: {}, art: art, personen: personen, termin: termin ? iso(termin) : null };
        qtys.forEach(function (i) { if (val(i) > 0) d.q[i.name] = val(i); });
        $$('input[name^="contact["], textarea[name^="contact["], select[name^="contact["]').forEach(function (el) {
          if (el.hasAttribute('data-wwb-qty') || el.type === 'hidden') return;
          if (el.type === 'radio') { if (el.checked) d.f[el.name] = el.value; } else d.f[el.name] = el.value;
        });
        sessionStorage.setItem(SPEICHER, JSON.stringify(d));
      } catch (e) {}
    }
    function stelleWiederHer() {
      var d; try { d = JSON.parse(sessionStorage.getItem(SPEICHER) || 'null'); } catch (e) {}
      if (!d) return;
      qtys.forEach(function (i) { if (d.q && d.q[i.name]) i.value = d.q[i.name]; });
      if (d.personen) personen = d.personen;
      if (d.art) { var r = form.querySelector('[data-wwb-art="' + d.art + '"]'); if (r) r.checked = true; art = d.art; }
      setzeArt(art);
      Object.keys(d.f || {}).forEach(function (n) {
        $$('[name="' + n.replace(/"/g, '\\"') + '"]').forEach(function (el) {
          if (el.type === 'radio') el.checked = el.value === d.f[n];
          else if (el.tagName !== 'SELECT') el.value = d.f[n];
        });
      });
      if (d.termin) { var t = new Date(d.termin + 'T00:00:00'); if (frei(t)) { termin = t; kalMonat = new Date(t.getFullYear(), t.getMonth(), 1); kalender(); zeiten(); if (d.f['contact[Abholzeit]']) zeitSel.value = d.f['contact[Abholzeit]']; } }
      if (plzFeld.value) pruefePlz();
      render();
    }
    form.addEventListener('input', speichere);
    form.addEventListener('change', speichere);
    form.addEventListener('click', function () { setTimeout(speichere, 0); });

    window.addEventListener('pageshow', function () {
      $$('input[name^="contact["], textarea[name^="contact["], select[name^="contact["]').forEach(function (el) { el.disabled = false; });
      qtys.forEach(function (i) { i.value = val(i); });
      setzeArt(art);
      var sb = form.querySelector('.wwb-submit'); if (sb) { sb.disabled = false; sb.textContent = 'Vorbestellung absenden'; }
      render();
    });

    setzeArt('abholung');
    stelleWiederHer();
    bandZeigen();
    rezepteZeigen();
  }

  function los() { [].slice.call(document.querySelectorAll('.wwb')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();
